/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import http from "../http-common";

const controller = "/falsePositiveReasons";
class FalsePositiveReasonsService {

    async getfalsepositivereasons() {
        const response = await http.get(`${controller}`);
        const data = response;
        return data;
    }
    
}

export default new FalsePositiveReasonsService();